import { useTranslation } from 'react-i18next';
import { resolveMediaUrl } from '../utils/mediaUrl';

export interface AvatarProps {
  src?: string | null;
  name?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
}

const sizeClasses: Record<NonNullable<AvatarProps['size']>, string> = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-12 w-12 text-base',
  lg: 'h-28 w-28 text-3xl',
};

export default function Avatar({ src, name, size = 'md', onClick, className = '' }: AvatarProps) {
  const { t } = useTranslation();
  const initials = (name ?? '?')
    .split(' ')
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const resolvedSrc = resolveMediaUrl(src);
  const dim = sizeClasses[size];

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full ring-2 ring-[rgba(255,255,255,0.1)] overflow-hidden ${dim} ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      {resolvedSrc ? (
        <img src={resolvedSrc} alt={name ? t('components.avatar.altWithName', { name }) : t('components.avatar.altGeneric')} className="h-full w-full object-cover" />
      ) : (
        <span className="h-full w-full flex items-center justify-center bg-gradient-to-br from-primary to-blue-600 text-white font-bold select-none">
          {initials}
        </span>
      )}
    </span>
  );
}
